<template>
  <section id="hero">
    <div
      id="heroCarousel"
      data-bs-interval="5000"
      class="carousel slide carousel-fade"
      data-bs-ride="carousel"
    >
      <ol class="carousel-indicators" id="hero-carousel-indicators">
        <li data-bs-target="#heroCarousel" data-bs-slide-to="0" class=""></li>
        <li
          data-bs-target="#heroCarousel"
          data-bs-slide-to="1"
          class="active"
          aria-current="true"
        ></li>
      </ol>
      <div class="carousel-inner" role="listbox">
        
        <div
          class="carousel-item active"
          style="background-image: url(assets/img/slide/slide-1.JPG)"
        >
          <div class="container slider-text">
            <h3>سبلان میکسر | تولید کننده انواع میکسر بتن</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

        <div
          class="carousel-item"
          style="background-image: url(assets/img/slide/slide-4.jpg)"
        >
          <div class="container slider-text">
            <h3>گروه صنعتی سبلان میکسر | تولید کننده میکسر بتن</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

        <div
          class="carousel-item"
          style="background-image: url(assets/img/slide/slide-5.jpg)"
        >
          <div class="container slider-text">
            <h3>سبلان میکسر | تعمیر و تامین تمامی قطعات میکسر</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

        <div
          class="carousel-item"
          style="background-image: url(assets/img/slide/slide-6.jpg)"
        >
          <div class="container slider-text">
            <h3>سبلان میکسر | پشتیبانی و خدمات پس از فروش</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

        <div
          class="carousel-item"
          style="background-image: url(assets/img/slide/slide-7.jpg)"
        >
          <div class="container slider-text">
            <h3>سبلان میکسر | مشاوره رایگان</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

        <div
          class="carousel-item"
          style="background-image: url(assets/img/slide/slide-8.jpg)"
        >
          <div class="container slider-text">
            <h3>سبلان میکسر | تولید کننده انواع میکسر بتن</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

        <div
          class="carousel-item"
          style="background-image: url(assets/img/slide/slide-10.jpg)"
        >
          <div class="container slider-text">
            <h3>سبلان میکسر | تولید کننده انواع میکسر بتن</h3>
            <p>
              سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش
              آلمان در ابعاد و طرح های مختلف
            </p>
          </div>
        </div>

      </div>
      <a
        class="carousel-control-prev"
        href="#heroCarousel"
        role="button"
        data-bs-slide="prev"
        ><span
          class="carousel-control-prev-icon bi bi-chevron-right"
          aria-hidden="true"
        ></span> </a
      ><a
        class="carousel-control-next"
        href="#heroCarousel"
        role="button"
        data-bs-slide="next"
        ><span
          class="carousel-control-next-icon bi bi-chevron-left"
          aria-hidden="true"
        ></span
      ></a>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .slider-text {
    display: none;
  }
}
</style>